import Ali from '../Assets/AliKhan.mp4';
import Harry from '../Assets/Harry.mp4';
import Nawroz from '../Assets/Nawroz.mp4';

export const birthdayVideos = {
  '2026-04-06': Harry,
  '2026-03-12': Ali,
  '2026-03-26': 'https://youtu.be/3JtQ78sqrr4',
  '2026-03-19': Nawroz,
  '2026-05-01': 'https://www.youtube.com/watch?v=rnRlftNxf_E&feature=youtu.be',
  '2026-05-22': 'https://www.youtube.com/watch?v=IsPZj2VrH4I',
  '2026-06-05': 'https://www.youtube.com/watch?v=IWl-L07uKbg',
  '2026-07-17': 'https://www.youtube.com/watch?v=xr1mWwFdjYY',
  '2026-08-14': 'https://youtu.be/UyuWOeTGDsc',
  '2026-08-24': 'https://youtu.be/d64DX8x7gYI',
  '2026-08-23': 'https://youtu.be/Km0OMo16CQU',
  '2026-08-25': 'https://youtu.be/TDUU-v9Qxjg',
  '2026-08-27': 'https://youtu.be/RSgrKaRDnBo',
  '2026-09-07': 'https://youtu.be/Iks5yAzt9Vw',
  '2026-09-16': 'https://youtu.be/YNUCTNxyC10',
  '2026-10-24': 'https://youtu.be/GXPyUz8HQGM',
  '2026-10-26': 'https://youtu.be/vN0XirS7uY0',
};

export function getTodayDate(date = new Date()) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function getBirthdayVideoForDate(dateString) {
  return birthdayVideos[dateString] || null;
}

export function hasBirthdayToday(date = new Date()) {
  return Boolean(getBirthdayVideoForDate(getTodayDate(date)));
}
